const ContentFilter = {
    accountName: "Enter account name",
    accountNum: "Enter account number",
    search: "Search",
    title: "Create residual cash payment out wizard",
};

const ContentTable = {
    create: "Create",
    noDataMsg: "No results have been found for the entered criteria",
    accountName: "Account name",
    accountNum: "Account number",
    company: "Company name",
    status: "Status",
    action: "Select account",
};

export { ContentFilter, ContentTable };
